import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { getMaijaRoutes, LOGIN_ROUTE, OVERVIEW_ROUTE } from "./Routes";
import LoginPage from "./pages/login/LoginPage";
import MaijaSnackbar from "./components/MaijaSnackbar";
import MaijaLoadingPage from "./components/MaijaLoadingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, AuthContext } from "./providers/AuthProvider";
import theme from "./theme";
import "./i18n";

function App() {
  const maijaRoutes = getMaijaRoutes();

  return (
    <AuthProvider>
      <AuthContext.Consumer>
        {({ isAuthenticated, loading }) => {
          if (loading) {
            return <MaijaLoadingPage isFullscreen />;
          }

          return (
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Router>
                <Routes>
                  <Route path={LOGIN_ROUTE.path} element={<LoginPage />} />

                  {isAuthenticated &&
                    maijaRoutes.map((route) => (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={<ProtectedRoute route={route}>{React.createElement(route.component)}</ProtectedRoute>}
                      />
                    ))}

                  <Route
                    path="*"
                    element={<Navigate to={isAuthenticated ? OVERVIEW_ROUTE.path : LOGIN_ROUTE.path} replace />}
                  />
                </Routes>
                <MaijaSnackbar />
              </Router>
            </ThemeProvider>
          );
        }}
      </AuthContext.Consumer>
    </AuthProvider>
  );
}

export default App;
